module.exports = "https://portperrypedals.ca/_res/img/ct-arrives.243b994.webp";